import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "sourceName", "sourceType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import isUndefined from 'lodash/isUndefined';
import omitBy from 'lodash/omitBy';
import { AnalyticsContext } from '@atlaskit/analytics-next';
export var extractContextualData = function extractContextualData(props) {
  var children = props.children,
    sourceName = props.sourceName,
    sourceType = props.sourceType,
    rest = _objectWithoutProperties(props, _excluded);
  var source = sourceName && sourceType ? "".concat(sourceName).concat(sourceType) : undefined;
  return omitBy(_objectSpread({
    source: source
  }, rest), isUndefined);
};
export var ContextWrapper = function ContextWrapper(props) {
  var data = extractContextualData(props);
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: data
  }, /*#__PURE__*/React.createElement(React.Fragment, null, props.children));
};